import { useState } from "react";
import get from "lodash/get";
import { useSite } from "@/context/SiteContext";

export const EditableText = ({ path, as: Tag = "span", multiline = false, className = "", testId }) => {
  const { content, patch, admin } = useSite();
  const value = get(content, path, "");
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState("");

  if (!admin) {
    return (
      <Tag className={className} data-testid={testId}>
        {value}
      </Tag>
    );
  }
  if (!open) {
    return (
      <Tag
        data-testid={testId}
        onClick={() => {
          setDraft(value);
          setOpen(true);
        }}
        title="Click to edit"
        className={`${className} cursor-text rounded-sm outline-dashed outline-1 outline-transparent transition-colors hover:outline-[#DA121A]/60`}
      >
        {value}
      </Tag>
    );
  }
  const commit = () => {
    if (draft !== value) patch(path, draft);
    setOpen(false);
  };
  const shared = {
    autoFocus: true,
    value: draft,
    onChange: (e) => setDraft(e.target.value),
    onBlur: commit,
    onKeyDown: (e) => {
      if (e.key === "Escape") setOpen(false);
      if (!multiline && e.key === "Enter") commit();
    },
    className: `${className} w-full bg-white/80 px-1 outline outline-1 outline-[#DA121A]/60 rounded-sm`,
    "data-testid": `${testId}-input`,
  };
  return multiline ? <textarea rows={4} {...shared} /> : <input {...shared} />;
};
